import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Link } from "react-router-dom";
import { useWallet } from '../WalletProvider';
import load from '../../img/load.gif'
import { useHistory } from "react-router-dom"

const btnStyle = {
    border: "2px solid #F5A425",
    background: "#17233A",
    color: "#fff",
    padding: "10px 10px",
    lineHeight: "22px"
}
function Header() {
    let history = useHistory();
    const queryParams = useMemo(() => new URLSearchParams(window.location.search), [])
    const currency = useRef(queryParams.get("currency"))
    const [currencyText, setCurrencyText] = useState(currency.current)
    const { account, metamaskconn, logout, tronConnect } = useWallet();
    const [cur, setCur] = useState(currency.current);
    const [showLoader, setShowLoader] = useState(false);
    const [showToggle, setShowToggle] = useState(false);
    function selectOption(event) {
        event.preventDefault()
        let x = event.target.value;
        setCurrencyText(x)
        const referrer = queryParams.get('referrer');
        if (referrer) {
            history.push(`?currency=${x}&referrer=${referrer}`)
        } else {
            history.push(`?currency=${x}`)
        }
    }
    useEffect(() => {
        setShowLoader(true)
        if (currency.current === '' || currency.current === null || currency.current === undefined) {
            const referrer = queryParams.get('referrer');
            if (referrer) {
                history.push(`?currency=eth&referrer=${referrer}`)
            } else {
                history.push(`?currency=eth`)
            }
            setShowLoader(false)
        } else {
            const referrer = queryParams.get('referrer');
            if (referrer) {
                setCur(`?currency=${currency.current}&referrer=${referrer}`)
            } else {
                setCur(`?currency=${currency.current}`)
            }
            setShowLoader(false)
        }
    }, [account, history, queryParams])
    return (
        <>
            <div className="ajax-loader" style={{ display: showLoader ? "flex" : "none" }}>
                <div style={{ textAlign: "center" }}>
                    <p id="loaderText" style={{ color: "#fff", fontSize: "20px" }}>Please wait....</p>
                    <img src={load} alt="" className="img-responsive" style={{ width: "90px" }} />
                </div>
            </div>

            <header className="main-header clearfix ">

                <div className='mx-3 d-flex justify-content-between'>
                    <div className="logo">
                        <Link to={'/' + cur}><em>Multi</em>TokenDrop</Link>
                    </div>
                    <div className='leftTogglebtn'>   
                        <div className="toggle-bar">   
                            <nav id="menu" className={showToggle ? 'main-nav sp1' : 'main-nav '} role="navigation">
                                <ul className="main-menu">
                                    <li><Link to={'/' + cur}>Home</Link></li>
                                    <li><Link to={'/vip' + cur}>VIP</Link></li>
                                    <li><Link to="/pricing">Pricing</Link></li>
                                    <li className="has-submenu"><p className='more-bttn'>More</p>
                                        <ul className="sub-menu">
                                            {/* <li><Link to={'/vip' + cur}>VIP</Link></li> */}
                                            <li><Link to={'/revoke' + cur}>Revoke</Link></li>
                                            <li><Link to={'/free-trial' + cur}>Free Trial</Link></li>
                                            <li><Link to={'/verification' + cur}>Verification</Link></li>
                                            {/* <li><Link to="/pricing">Pricing</Link></li> */}
                                            <li><Link to="/contact-us">Contact</Link></li>
                                            <li><Link to="/referral">Referral</Link></li>
                                            <li><Link to="/faq">FAQ</Link></li>
                                        </ul>
                                    </li>
                                    {account === null || account === 'undefined' || !account ? (
                                        currency.current !== "trx" ?
                                            (
                                                <>
                                                    {/* <li><button type="button" style={btnStyle} className="external" id="unlock" onClick={connectWalletConnect}>Wallet Connect</button></li> */}
                                                    <li className='head-bttn'><button type="button" style={btnStyle} className="external" id="unlock" onClick={metamaskconn}>Metamask</button></li>
                                                </>
                                            ) : (<li><button type="button" style={btnStyle} className="external" id="unlock" onClick={tronConnect}>Tron</button></li>)
                                    ) : (
                                        <>
                                            <li><p>{account.substr(0, 5)}....{account.substr(-5)}</p></li>
                                            <li><button type="button"  className="external log-bttn" id="unlock" onClick={logout}>Log out</button></li>
                                        </>
                                    )}
                                </ul>
                            </nav>
                        </div> 
                        <select id="select_option" value={currencyText} onChange={selectOption}>
                            <option value={"eth"}>ETH </option>
                            <option value={"bnb"}>BNB</option>
                            <option value={"matic"}>POLYGON</option>
                            <option value={"avax"}>AVALACHE</option>
                            <option value={"trx"}>TRX</option>
                        </select>
                        <a href="#menu" onClick={() => { setShowToggle(!showToggle) }} className="menu-link"><i className="fa fa-bars"></i>
                        </a>
                    </div>
         
                </div>
            </header>
        </>
    )
}
export default Header